import { n as a, t as w, u as y, i as H } from './fluorescent-dom.es-Cu7dY8l0.js'
import { f as D, a as M, b as v, c as x, A as $ } from './filter-sidebar-Hm5CBW5E.js'
import { r as R } from './index-DM5rHkdJ.js'
import { a as A } from './at-breakpoint-change-DVsQWIFj.js'
import { g as E } from './media-queries-CokWIw5y.js'
import { P as g } from './product-item-Du4jXRmW.js'
import { s as j } from './sticky-scroll-DbZYdC-l.js'
import { r as C } from './evx.es-D_-Lbk8t.js'
import { i as k } from './intersection-watcher-D3vtB7Co.js'
import { d as F } from './delay-offset-DYAL33nW.js'
import { s as B } from './shouldAnimate-BMbjctYf.js'
import { f as U, p as G } from './fetch-data-B0wXl5NB.js'
import './main-BCFY9a9_.js'
import './focus-trap.esm-kenzGRES.js'
import './bodyScrollLock.esm-CT-oBNdc.js'
import './slide-anim.module-BFvSBue6.js'
import './update-inner-html-D7dYCKPv.js'
import './debounce-ByPGBjlu.js'
import './cart-Dp1qr_mc.js'
import './storage-CVUx8WVm.js'
import './provide-resize-observer-CfYb1w0R.js'
const h = {
    stickyHeader: ".header[data-enable-sticky-header='true']",
    partial: '[data-partial]',
    filterBar: '[data-filter-bar]',
    mobileFilterBar: '[data-mobile-filters]',
    productItems: '.animation--item:not(.animation--item-revealed)',
  },
  P = {
    hideProducts: 'animation--collection-products-hide',
    itemRevealed: 'animation--item-revealed',
    stickyFilterBar: 'filter-bar--sticky',
  },
  L = (t) => {
    const i = a(h.stickyHeader, document),
      o = a(h.partial, t),
      r = a(h.filterBar, t),
      e = a(h.mobileFilterBar, t)
    let n = null
    r && (n = k(r, !0))
    let l = null
    ;(e && (l = k(e, !0)), c())
    function c() {
      let d = w(h.productItems, t)
      ;(F(t, [h.productItems]),
        setTimeout(() => {
          y(d, P.itemRevealed)
        }, 0))
    }
    function p() {
      const d = i ? i.getBoundingClientRect().height / 2 : 0,
        m = t.getBoundingClientRect().top + window.pageYOffset - d
      window.scrollTo({ top: m, behavior: 'smooth' })
    }
    function u() {
      ;(c(), H(o, P.hideProducts), p())
    }
    function f() {
      c()
    }
    return {
      updateContents: u,
      infiniteScrollReveal: f,
      destroy() {
        ;(n == null || n.destroy(), l == null || l.destroy())
      },
    }
  },
  I = { plpAjax: '[data-plp-ajax]', paginate: '[data-plp-paginate]', plpItem: '[data-plp-item]' },
  Q = () => {
    const i = new URLSearchParams(window.location.search).get('page')
    return i ? parseInt(i) : 1
  },
  V = (t, i, o) => {
    let r = o
    if (i === 1) return t.slice(0, r)
    let e = r + (i - 2) * o,
      n = e + o
    return t.slice(e, n)
  },
  z = (t, i, o, r, e) => {
    const n = V(i, o, r)
    ;((t.innerHTML = ''),
      n.forEach((l) => {
        t.innerHTML += l
      }),
      g(e),
      B(e) && L(e),
      C('collection:updated'))
  },
  _ = async (t) => {
    let i = Q()
    const { collectionItemCount: o, sectionId: r, collectionItemsPerPage: e } = t.dataset,
      n = a(I.plpAjax, t)
    if (!n) return
    const l = parseInt(o || 0),
      c = a(I.paginate, t),
      p = parseInt(e || 12),
      u = Math.ceil((l + 1) / p),
      f = new URLSearchParams(window.location.search),
      d = f.get('sort_by') ? `&sort_by=${f.get('sort_by')}` : '',
      m = await U(1, u, r, I.plpItem, d)
    if (!m.length) return
    z(n, m, i, p, t)
    const b = G(i, u, 4, d)
    b && c && (c.innerHTML = b)
  },
  s = {
    infiniteScrollContainer: '.collection__infinite-container',
    infiniteScrollTrigger: '.collection__infinite-trigger',
    partial: '[data-partial]',
    filterDrawer: '[data-filter-drawer]',
    filterBar: '[data-filter-bar]',
    filterSidebar: '[data-filter-sidebar]',
    loader: '.collection__loading',
    paginationItemCount: '[data-pagination-item-count]',
    productItems: '.product-item',
  },
  S = { active: 'is-active', hideProducts: 'animation--collection-products-hide' },
  { strings: T } = window.theme
R('collection', {
  infiniteScroll: null,
  onLoad() {
    const { collectionItemCount: t, paginationType: i } = this.container.dataset
    parseInt(t) &&
      ((this.filterDrawerEl = a(s.filterDrawer, this.container)),
      (this.filterbarEl = a(s.filterBar, this.container)),
      (this.paginationItemCount = a(s.paginationItemCount, this.container)),
      (this.filterDrawerEl || this.filterbarEl) &&
        ((this.partial = a(s.partial, this.container)),
        (this.filterDrawer = D(this.container)),
        (this.filterBar = M(this.container)),
        (this.filterSidebar = v(this.container)),
        (this.filterHandler = x({ container: this.container, renderCB: this._renderView.bind(this) })),
        this.filterSidebar &&
          this.container.dataset.enableStickyFilterSidebar === 'true' &&
          ((this.mobileQuery = window.matchMedia(E('below-960'))),
          this._initStickyScroll(),
          (this.breakPointHandler = A(960, () => {
            this._initStickyScroll()
          })))),
      (this.paginationType = i),
      (this.paginated = this.paginationType === 'paginated'),
      (this.infiniteScrollTrigger = a(s.infiniteScrollTrigger, this.container)),
      this.paginated || this._initInfiniteScroll(),
      (this.productItem = g(this.container)),
      B(this.container) && (this.animateCollection = L(this.container)),
      (this.plpAjax = _(this.container)),
      this.updateGridItems(),
      window.addEventListener('resize', () => this.updateGridItems()))
  },
  _initStickyScroll() {
    this.mobileQuery.matches
      ? this.stickyScroll && (this.stickyScroll.destroy(), (this.stickyScroll = null))
      : this.stickyScroll || (this.stickyScroll = j(this.container))
  },
  _initInfiniteScroll() {
    const t = {
      container: s.infiniteScrollContainer,
      pagination: s.infiniteScrollTrigger,
      loadingText: 'Loading...',
      callback: () => {
        var i
        ;(this.productItem && this.productItem.unload(),
          (this.productItem = g(this.container)),
          (i = this.animateCollection) == null || i.infiniteScrollReveal(),
          this._updatePaginationCount(),
          C('collection:updated'))
      },
    }
    ;(this.paginationType === 'click' && (t.method = 'click'), (this.infiniteScroll = new $(t)))
  },
  _updatePaginationCount() {
    const t = w(s.productItems, this.container).length,
      i = T.pagination.viewing
        .replace('{{ of }}', `1-${t}`)
        .replace('{{ total }}', this.partial.dataset.collectionProductsCount)
    this.paginationItemCount.innerHTML = `${i} ${T.pagination.products}`
  },
  _renderView(t, i = !0) {
    const o = `${window.location.pathname}?section_id=${this.container.dataset.sectionId}&${t}`,
      r = a(s.loader, this.container)
    ;(y(this.partial, S.hideProducts),
      y(r, S.active),
      fetch(o)
        .then((e) => e.text())
        .then((e) => {
          var c
          i && this._updateURLHash(t)
          const n = new DOMParser().parseFromString(e, 'text/html'),
            l = a(s.partial, n)
          ;((this.partial.innerHTML = l.innerHTML),
            (this.partial.dataset.collectionProductsCount = l.dataset.collectionProductsCount),
            (c = this.animateCollection) == null || c.updateContents(),
            !this.paginated &&
              this.infiniteScrollTrigger &&
              ((this.infiniteScrollTrigger.innerHTML = ''), this._initInfiniteScroll()),
            this.filterDrawer && this.filterDrawer.renderFilters(n),
            this.filterBar && this.filterBar.renderFilters(n),
            this.filterSidebar && this.filterSidebar.renderFilters(n),
            this.productItem && this.productItem.unload(),
            (this.productItem = g(this.container)),
            (this.paginationItemCount = a(s.paginationItemCount, this.container)),
            (this.plpAjax = _(this.container)),
            H(r, S.active),
            C('collection:updated'))
        }))
  },
  _updateURLHash(t) {
    history.pushState({ searchParams: t }, '', `${window.location.pathname}${t && '?'.concat(t)}`)
  },
  updateGridItems() {
    const t = w(s.productItems, this.container),
      i = parseInt(this.container.dataset.collectionColumnsDesktop),
      o = parseInt(this.container.dataset.collectionColumnsMobile)
    let r = 2
    ;(window.innerWidth >= 768 ? (r = i || 4) : (r = o || 2),
      t.forEach((e, n) => {
        ;(e.classList.remove('first-item'), n % r === 0 && e.classList.add('first-item'))
      }))
  },
  onUnload() {
    var t
    ;(this.infiniteScroll && this.infiniteScroll.destroy(),
      this.filterHandler && this.filterHandler.unload(),
      this.filterDrawer && this.filterDrawer.unload(),
      this.filterBar && this.filterBar.unload(),
      this.filterSidebar && this.filterSidebar.unload(),
      this.filtering && this.filtering.unload(),
      this.productItem && this.productItem.unload(),
      this.plpAjax && this.plpAjax.unload(),
      (t = this.animateCollection) == null || t.destroy())
  },
})
